export default __webpack_public_path__ + "static/media/Group2601.5de757d3.png";